import { Component, inject, signal, effect, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContractRestService} from '../../core/api/contract-rest.service';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCardModule } from '@angular/material/card';
import { PageRequest, PageResponse, Template } from '../../core/models/template.model';
import { Router } from '@angular/router';
import { ContractService } from '../../core/services/contract.service';

@Component({
  selector: 'app-templates-list',
  imports: [CommonModule,
    MatTableModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatTooltipModule
  ],
  templateUrl: './templates-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './templates-list.component.scss',
})
export class TemplatesListComponent {
  private contractRestService: ContractRestService = inject(ContractRestService);
  pageRequest = signal<PageRequest>({
    page: 0,
    size: 10,
    sort: ['createdAt,desc']
  });

  displayedColumns: string[] = ['name', 'description', 'createdAt', 'updatedAt', 'actions'];

  templates = signal<PageResponse<Template> | undefined>(undefined);
  loading = signal<boolean>(false);
  error = signal<Error | undefined>(undefined);
  private contractService: ContractService = inject(ContractService);

  private router = inject(Router);

  constructor() {
    effect(() => {
      this.contractService.currentTemplate.set(0);
      this.contractService.editTemplate.set(false);
      this.loadTemplates(this.pageRequest());
    });
  }

  private async loadTemplates(request: PageRequest): Promise<void> {
    this.loading.set(true);
    this.error.set(undefined);

    try {
      const data = await this.contractRestService.getTemplates(request);
      this.templates.set(data);
    } catch (err) {
      this.error.set(err as Error);
    } finally {
      this.loading.set(false);
    }
  }

  async onPageChange(event: PageEvent): Promise<void> {
    this.pageRequest.set({
      page: event.pageIndex,
      size: event.pageSize,
      sort: this.pageRequest().sort
    });

    await this.loadTemplates(this.pageRequest());
  }

  viewTemplate(id: string): void {
    console.log('View template:', id);
  }

  editTemplate(id: number): void {
    this.contractService.currentTemplate.set(id);
    this.contractService.editTemplate.set(true);
    this.navigateToNewTemplate();
  }

  async deleteTemplate(id: string): Promise<void> {
    try {
      await this.contractRestService.deleteTemplate(id);
      await this.loadTemplates(this.pageRequest());
    } catch (error) {
      console.error('Error deleting template:', error);
    }
  }

  refresh(): void {
    this.loadTemplates(this.pageRequest());
  }

  navigateToNewTemplate(): void {
    this.router.navigate(['/neue-vorlage']);
  }
}
